import { commitTag } from './__generated__/commitTag.json';

export function getCommitTag(): string | null {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  const tag = commitTag as string;
  if (Boolean(tag) && tag.length > 0) {
    return tag;
  }

  return null;
}
